import React from "react";
import { StyledCookieMessage } from "./styles";

const termsCookieKey = "absCookiesAccepted";
const termsAcceptedCookie = `${termsCookieKey}=true`;

export function acceptedTerms() {
  return document.cookie.split("; ").some(c => c === termsAcceptedCookie);
}

export function acceptTerms() {
  document.cookie = `${termsAcceptedCookie};expires=Fri, 31 Dec 9999 23:59:59 GMT`;
}

export function rejectTerms() {
  document.cookie = `${termsCookieKey}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

interface CookieMessageProps {
  alwaysShow: boolean;
}

interface CookieMessageState {
  acceptedTerms: boolean;
}

export default class CookieMessage extends React.Component<
  CookieMessageProps,
  CookieMessageState
> {
  static defaultProps = {
    alwaysShow: false
  };

  constructor(props: CookieMessageProps) {
    super(props);
    this.state = { acceptedTerms: acceptedTerms() };
  }

  toggleAcceptance() {
    const acceptedTerms = !this.state.acceptedTerms;
    this.setState({ acceptedTerms });
    acceptedTerms ? acceptTerms() : rejectTerms();
  }

  render() {
    const { alwaysShow, children, ...restProps } = this.props;
    const { acceptedTerms } = this.state;

    if (!alwaysShow && acceptedTerms) return null;

    return (
      <StyledCookieMessage {...restProps}>
        <div className="cookie-message__body">{children}</div>
        <div className="cookie-message__action">
          <button
            className="cookie-message__button"
            onClick={() => this.toggleAcceptance()}
          >
            {acceptedTerms ? "Reject" : "Accept"}
          </button>
        </div>
      </StyledCookieMessage>
    );
  }
}
